export {
    default as TemplateChat,
    ITemplateChatProps,
} from './chat';
